var _path, _rect, _rect2, _rect3, _rect4, _polygon, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Reports") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.52.88a.94.94,0,0,0-.7-.79l-.12,0H2.3l-.12,0a.94.94,0,0,0-.7.79.3.3,0,0,0,0,.1V14a1.18,1.18,0,0,0,0,.2.94.94,0,0,0,.86.7H12.64a.94.94,0,0,0,.86-.7,1.18,1.18,0,0,0,0-.2V1S13.53.91,13.52.88ZM12.28,13.69H2.72V1.34h9.56Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.47,
    y: 8.04,
    width: 1.35,
    height: 4.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.16,
    y: 8.04,
    width: 1.35,
    height: 4.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.01,
    y: 9.09,
    width: 1.35,
    height: 3.89
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.72,
    y: 6.24,
    width: 1.35,
    height: 6.74
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4.14 6.83 3.7 6.35 6.34 3.93 8.9 5.74 10.95 4.09 11.36 4.6 8.92 6.55 6.39 4.76 4.14 6.83"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.72,
    y: 2.35,
    width: 7.58,
    height: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.dc84aa067968417ccde81c4716efeec2.svg";
export { ForwardRef as ReactComponent };